import React from "react";
import { Controller, useForm } from "react-hook-form";

import { cn } from "../../utils/utils";

const PassportInput = ({ control, name, label, errors, className, placeholder }) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  return (
    <div className={cn("col-span-2 flex flex-col gap-2 relative", className)}>
      <label htmlFor={name}>{label}</label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, disabled } }) => {
          const handleCharacterChange = (char) => {
            const newValue = char + (value?.slice(1) || "");
            ////console.log(newValue, "newValue");
            onChange(newValue);
          };

          const handleNumberChange = (e) => {
            const numbers = e.target.value.slice(0, 8);
            const newValue = (value ? value.charAt(0) : "") + numbers;
            onChange(newValue);
          };

          return (
            <div className="col-span-2 xl:col-span-1 flex  gap-2 relative">
              <input
                type="number"
                autoFocus={false}
                value={value?.slice(1) || ""}
                onChange={handleNumberChange}
                disabled={disabled}
                className="h-[52px] px-4  outline-none rounded-v-md  w-full border border-neutral-30 disabled:bg-neutral-10"
                placeholder={placeholder}
                maxLength={8}
                onWheel={(e) => e.target.blur()}
              />
              <div className="relative h-[52px]  outline-none   w-full border border-neutral-30">
                <select
                  disabled={disabled}
                  onChange={(e) => handleCharacterChange(e.target.value)}
                  className="w-full h-full appearance-none px-4 disabled:bg-neutral-10 "
                >
                  <option disabled value={""}>
                    انتخاب کنید
                  </option>
                  {characters.map((char) => (
                    <option key={char} value={char}>
                      {char}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center px-2 text-gray-700">
                  <svg
                    className="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
          );
        }}
      />
      {errors?.message && <span className="text-red-500 text-sm">{errors?.message}</span>}
    </div>
  );
};

export default PassportInput;
